import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/style.css'
import globalConfig from './utils/globalConfig'
import { isTokenExist, saveToken } from './utils/utils.js'


Vue.use(globalConfig)


Vue.prototype.isTokenExist = isTokenExist
Vue.prototype.saveToken = saveToken

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
